import { PropsWithChildren } from "react";
import { useFeatureFlags } from "~/contexts/feature-flag-context";
import { NotFound } from "~/pages/not-found";

type ManuscriptRouteGuardProps = PropsWithChildren<{
  allowTeaser?: boolean;
}>;

export function ManuscriptRouteGuard({
  children,
  allowTeaser = false,
}: ManuscriptRouteGuardProps) {
  const { features } = useFeatureFlags();

  if (!features.uploadManuscript) {
    if (allowTeaser && features.uploadManuscriptTeaser) {
      return children;
    }
    return <NotFound />;
  }

  return children;
}
